import axios from "axios";
import { stringify as paramsSerializer } from "qs";
import { getToken } from "./token";
import config from "../config";
import { v1 as uuid1 } from "uuid";

const deviceId = uuid1();
const getBaseURL = (version = config.version) =>
  `${!config.isDevelopmentMode ? config.backendURL : ""}/${config.apiPrefix}/${version}/`;

const CancelToken = axios.CancelToken;
let source = CancelToken.source();

export const request = async ({ apiVersion, ...config }) => await new Promise(((resolve, reject) => {
  axios({
    baseURL: getBaseURL(apiVersion),
    paramsSerializer,
    cancelToken: source.token,
    validateStatus: (status) => {
      return true;
    },
    ...config,
  })
    .then((response) => {
      if (response.status >= 400) {
        reject(response?.data);
      } else {
        resolve(response?.data);
      }
    })
    .catch(thrown => {
      if (axios.isCancel(thrown)) {
        console.log("Request canceled", thrown.message);
      } else {
        reject(thrown.response?.data);
      }
    });
}));

export const ctgBackendRequest = async config => {
  const reqConfig = {
    timeout: 0,
    ...config,
    headers: {
      "X-User-Agent": "web",
      "App-Version": 1,
      "Content-Type": "application/json",
      "Accept": "application/json",
      "Device-Id": deviceId,
      ...config.headers,
    },
  };

  const isChromium = window.chrome;
  const winNav = window.navigator;
  const vendorName = winNav.vendor;
  const isOpera = typeof window.opr !== "undefined";
  const isIEedge = winNav.userAgent.indexOf("Edge") > -1;
  const isIOSChrome = winNav.userAgent.match("CriOS");

  if (isIOSChrome) {
    // is Google Chrome on IOS
  } else if (
    isChromium !== null &&
    typeof isChromium !== "undefined" &&
    vendorName === "Google Inc." &&
    isOpera === false &&
    isIEedge === false
  ) {
    // is Google Chrome
  } else {
    // not Google Chrome
    reqConfig["User-Agent"] = "web";
  }

  return await request(reqConfig);
};

export const authRequest = async config =>
  await ctgBackendRequest({
    timeout: 0,
    ...config,
    headers: {
      Authorization: `Bearer ${getToken()}`,
      ...config.headers,
    },
  });


export const cancelAllRequests = () => {
  source.cancel("Operation canceled by the user.");
  source = CancelToken.source();
};

